import authReducer from "./reducers/authReducer";
import assetReducer from "./reducers/assetReducer";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: {
    authReducer,
    assetReducer,
  },
});

export default store;
